import { UsageContent } from './UsageContent';

export const UsagePage = () => (
  <div className="mt-[20px]">
    <UsageContent showOverageSummary={false} showManageUsersLink={false} />
  </div>
);
